import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { splitTime } from "../../../_helper";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSingleCourse,
  rateSingleCourse,
} from "../../../Redux/PartnersCourses/PartnersCoursesActions";
import RatingReview from "../../../Components/RatingReview";
import PageTitle from "../../../Components/UI/PageTitle";
import RowLoader from "../../../Components/UI/RowLoader";
import Loader from "../../../Components/Loader";
import LessonsInCourseForClient from "../../../Components/SingleCourseComponents/LessonsInCourseForClient";
import Swal from "sweetalert2";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import { clearData } from "../../../Redux/PartnersCourses/PartnersCoursesSlice";

const SingleCourse = () => {
  const { singleCourseInfo, isLoading, rateLoading, error } = useSelector(
    (state) => state?.partnersCourses
  );
  const { lang } = useSelector((state) => state?.UI);
  const [rating, setRating] = useState(0);
  const [reviewValue, setReviewValue] = useState([]);
  const isRateChange =
    rating === singleCourseInfo?.client_rating?.rate &&
    reviewValue === singleCourseInfo?.client_rating?.review;
  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSubmitReview = () => {
    if (isRateChange) return;
    dispatch(rateSingleCourse(id, rating, reviewValue));
    Swal.fire({
      icon: "success",
      title: "Thank you!",
      text: "Thanks for rating the course!",
    });
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchSingleCourse(id));
    }
    return () => {
      dispatch(clearData());
    };
  }, [id, dispatch]);

  useEffect(() => {
    setRating(singleCourseInfo?.client_rating?.rate);
    setReviewValue(singleCourseInfo?.client_rating?.review);
  }, [
    singleCourseInfo?.client_rating?.rate,
    singleCourseInfo?.client_rating?.review,
  ]);

  if (isLoading) return <Loader />;
  if (error) return <ErrorAnimationComponent message={error} />;

  return (
    <>
      <PageTitle
        title={singleCourseInfo[`course_name_${lang}`]}
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "My Courses",
            link: `/partners/my-courses`,
          },
          { title: singleCourseInfo[`course_name_${lang}`] },
        ]}
      />
      <div className="row">
        <div className="col-lg-8">
          <div className="card">
            {singleCourseInfo?.course_promo_video && (
              <iframe
                title={singleCourseInfo?.courseName}
                src={`${singleCourseInfo?.course_promo_video}`}
                width="100%"
                height="480"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            )}
            <div className="card-body tw-text-center">
              {singleCourseInfo[`course_description_${lang}`]}
            </div>
          </div>
          <div className="card">
            <LessonsInCourseForClient id={singleCourseInfo?.course_id} />
          </div>
        </div>
        <div className="col-lg-4">
          {singleCourseInfo?.instructor?.length > 0 &&
            singleCourseInfo?.instructor?.map((instructor) => (
              <div className="card" key={instructor?.instructor_id}>
                <div className="card-header">
                  <div className="media align-items-center">
                    <div className="media-left">
                      <div
                        className=" rounded-circle tw-overflow-hidden"
                        style={{ width: 75, height: 75 }}
                      >
                        <img
                          src={
                            instructor[`instructor_image`] ||
                            "/imgs/partner.png"
                          }
                          alt={instructor[`instructor_name_${lang}`]}
                          className="w-100 h-100 object-fit-cover"
                        />
                      </div>
                    </div>

                    <div className="media-body d-flex flex-column">
                      <h4 className="card-title">
                        <span href="fixed-instructor-profile.html">
                          {instructor[`instructor_name_${lang}`]}
                        </span>
                      </h4>
                      <p className="card-subtitle">
                        {instructor[`instructor_title_${lang}`]}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card-body tw-text-center">
                  <p>{instructor[`instructor_bio_${lang}`]}</p>
                </div>
              </div>
            ))}

          {singleCourseInfo?.socials?.length > 0 && (
            <div className="card">
              <div className="card-header">
                <div className="media">Social Media Channels</div>
              </div>
              <div
                className="card-body d-flex tw-flex-wrap tw-gap-4 tw-justify-around"
                style={{ gap: 10 }}
              >
                {singleCourseInfo?.socials?.map((sml) => (
                  <a
                    href={sml?.link}
                    target="_blank"
                    rel="noreferrer"
                    key={sml?.id}
                    className="fs-3 text-primary tw-flex tw-flex-col tw-items-center tw-cursor-pointer"
                  >
                    <i
                      className={`fa fa-${sml?.platform_name?.toLowerCase()}`}
                    ></i>
                    <p className="!tw-text-[12px]">{sml?.channel_name}</p>
                  </a>
                ))}
              </div>
            </div>
          )}

          <div className="card">
            <ul className="list-group list-group-fit">
              <li className="list-group-item">
                <div className="media align-items-center">
                  <div className="media-left">
                    <i className="material-icons text-muted-light">schedule</i>
                  </div>
                  <div className="media-body">
                    {splitTime(singleCourseInfo?.course_duration)?.hours}{" "}
                    <small className="text-muted">hrs</small> &nbsp;{" "}
                    {splitTime(singleCourseInfo?.course_duration)?.mins}{" "}
                    <small className="text-muted">min</small>
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <div className="media align-items-center">
                  <div className="media-left">
                    <i className="material-icons text-muted-light">
                      assessment
                    </i>
                  </div>
                  <div className="media-body flex flex-column">
                    {singleCourseInfo?.course_level}
                    <div className=""></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* Course Rating */}
          <div className="card">
            <div className="card-header tw-flex tw-justify-between tw-items-center">
              <h4 className="card-title !tw-m-0">Course Rate</h4>
              <RatingReview
                totalStars={5}
                currentRating={singleCourseInfo?.course_rating || 0}
                editable={false}
              />
            </div>
          </div>

          <div className="card">
            <div className="card-header tw-flex tw-justify-between tw-items-center">
              <h4 className="card-title !tw-m-0">Your Rate</h4>
              <p className="tw-text-md tw-text-yellow-500">{rating}</p>
            </div>
            <div className="card-body d-flex flex-column">
              <RatingReview
                totalStars={5}
                currentRating={rating}
                onRatingChange={handleRatingChange}
                editable={true} // Allows editing
              />
              <textarea
                value={reviewValue}
                onChange={(e) => setReviewValue(e.target.value)}
                className="form-control mt-2"
                placeholder="please add you review here"
              ></textarea>

              {rating > 0 &&
                reviewValue?.trim("").length > 0 &&
                !isRateChange && (
                  <div className="tw-mt-4 tw-mr-auto">
                    <button
                      onClick={handleSubmitReview}
                      className="btn btn-white ml-auto !tw-w-[100px]"
                    >
                      {rateLoading ? (
                        <RowLoader paddingStyle="tw-py-0" />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleCourse;
